<template>
  <div class="tile">
    <div class="tile__header" :style="`background: ${tile.bgColor}`">
      <h3 v-text="tile.title"></h3>
      <img class="tile__header__image" :src="(tile.icon.url) ? tile.icon.url : tile.icon" />
    </div>
    <div class="tile__actions">
      <div
        v-for="(action, key) in tile.actions"
        :key="key"
        class="tile__actions__action"
      >
        <TileAction :action="action" :background="tile.bgColor" />
      </div>
    </div>
    <feature-loader v-if="tile.contentFeature && tile.contentFeatureName" :feature="tile.contentFeatureName" />
    <div
      v-else
      class="tile__content"
      v-html="tile.content"
    >
    </div>
    <h3 class="ml--3 mb--0">Other Benefits</h3>
    <div class="tile__other-tiles">
      <div
        v-for="(tile, key) in otherTiles"
        :key="key"
        class="tiles__tile tiles__tile--wide"
        @click="goToLink(tile)"
      >
        <div class="tiles__tile__header" :style="`background: ${tile.bgColor}`">
          <h5 class="m--0" v-text="tile.title"></h5>
        </div>
        <div class="tiles__tile__body">
          <p v-text="splitContent(tile.content)"></p>
        </div>
        <img :src="(tile.icon.url) ? tile.icon.url : tile.icon" />
      </div>
    </div>
    <div class="tile__actions__action separate" v-if="hasLetter">
      <a
        :href="hasLetter"
        target="_blank"
      >
        <button
          class="btn"
          :style="`background: rgb(250, 194, 39)`"
          v-text="'View Letter'"
        >
        </button>
      </a>
    </div>
  </div>
</template>

<script>
import FeatureLoader from '../components/FeatureLoader'
import TileAction from '../components/TileAction'

export default {
  name: 'tile',
  components: {
    FeatureLoader,
    TileAction
  },
  data: () => ({
    hasLetter: false
  }),
  computed: {
    tile () {
      let pathChunks = this.$route.path.split('/')

      if (pathChunks.length > 2) {
        let currentTile = this.$store.getters.tiles.filter(item => item.path === `/${pathChunks[1]}`)[0]
        return currentTile.children.filter(item => item.path === this.$route.path)[0]
      }
      return this.$store.getters.tiles.filter(item => item.path === this.$route.path)[0]
    },
    otherTiles () {
      let pathChunks = this.$route.path.split('/')

      if (pathChunks.length > 2) {
        let currentTile = this.$store.getters.tiles.filter(item => item.path === `/${pathChunks[1]}`)[0]
        return currentTile.children.filter(item => item.path !== this.$route.path)
      }

      return this.$store.getters.tiles.filter(item => item.path !== this.$route.path)
    }
  },
  methods: {
    goToLink(tile) {
      if (!tile.sso) {
        return this.$router.push(tile.path)
      }

      this.$root.handleTileSSO(tile)
    },
    splitContent (content) {
      let withoutTags = content.replace(/<[^>]*>/g, ' ')
      return withoutTags.split('.')[0]
    },
    scrollTop () {
      if (document.getElementById('main-container').scrollTop <= 0) {
        return
      }

      setTimeout(() => {
        document.getElementById('main-container').scrollTop -= 10
        this.scrollTop()
      }, 10)
    }
  },
  async mounted () {
    if (this.tile.title == 'Pay & Pension') {
      const { data } = await window.axios.get(`${this.$store.getters.portalEndpoint}/get-letters?clientId=${this.$store.getters.user.client_id}&identifier=${this.$store.getters.user.identifier}`) 
      if (data.errorType || data.errorMessage) return
      this.hasLetter = data
    }
  }
}
</script>
<style lang="scss" scoped>
  .separate {
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;

    button {
      font-size: 10px;
      padding: 5px 10px;
    }
  }
</style>